import styled from '@emotion/styled'

export const RowWrapper = styled.div<{ styleRow?: string }>`
  display: flex;
  align-items: start;
  column-gap: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
  }

  ${(props: any) => props.styleRow}
`
